import { getChinaAndroidTrialProductId } from '@forest/paywall-core'
import { api } from '~/services/api'

const CHINA_ANDROID_TRIAL_PRODUCT_ID = getChinaAndroidTrialProductId(
  import.meta.env.MODE,
)

interface OwnPurchaseStatsResponse {
  stats: {
    month_count: number
    today_count: number
    total_count: number
  }
}

export async function getChinaAndroidTrialEligibility(
  userId: number,
): Promise<'available' | 'unavailable'> {
  if (!CHINA_ANDROID_TRIAL_PRODUCT_ID) return 'unavailable'
  try {
    const response = await api.service
      .get(
        `store/users/${userId}/product/${CHINA_ANDROID_TRIAL_PRODUCT_ID}/own-purchase-stats`,
      )
      .json<OwnPurchaseStatsResponse>()
    return response.stats.total_count > 0 ? 'unavailable' : 'available'
  } catch {
    return 'unavailable'
  }
}
